module.exports = __webpack_public_path__ + "static/409-70844abd796adff52458eb2e1ee2d3cc.png";